export default function MySQL_SUM() {
  return (
    <div>
      <h2>MySQL_SUM</h2>    </div>
  );
}